/* eslint-disable max-classes-per-file */
class FostrVariantRadios extends VariantSelects {
  constructor() {
    super();

    this.checkAllStock();
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.checkStock(e);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.removeSelectVariantErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if (!this.dataset.noMedia) {
        this.updateMedia();
      }
      if (!this.dataset.noUrl) {
        // check if this is a product card
        if (!this.closest('.card-wrapper')) {
          this.updateURL();
        }
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.renderVariantStockInfo();
    }
  }

  removeSelectVariantErrorMessage() {
    let selectVariantEl = this.parentElement.querySelector('product-form .error-message--select-variant');
    if (!selectVariantEl) {
      // check for shop the look
      if (this.parentElement.classList.contains('shop-the-look-prod-variants')) {
        selectVariantEl = this.parentElement.parentElement.querySelector('product-form .error-message--select-variant');
      }
    }

    selectVariantEl?.classList.add('hidden');
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    let options = [];

    // check all fieldsets for checked radios if value is undefined
    for (let i = 0; i < fieldsets.length; i += 1) {
      const fieldset = fieldsets[i];
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (checkedRadio) {
        // push value to options array
        options.push(checkedRadio.value);
      } else {
        // Get first input[type="radio",name="Color"] value and push to options array
        const firstRadio = Array.from(fieldset.querySelectorAll('input[type="radio"][name="color" i]'))[0];
        if (firstRadio) {
          firstRadio.checked = true;
          options.push(firstRadio.value);
        }
      }
    }

    // update this.options
    this.options = options;
    this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
  }

  checkStock(e) {
    if (!!this.querySelector(`label[for="${e.target.id}"]`).classList.contains('unavailable')) {
      document.querySelector('.product-form__buttons .product-form__submit')?.classList.add('hidden');
      document.querySelector('.product-form__buttons .klaviyo-bis-trigger')?.classList.remove('hidden');
      document.querySelector('.message__out-of-stock')?.classList.remove('hidden');
    } else {
      document.querySelector('.product-form__buttons .product-form__submit')?.classList.remove('hidden');
      document.querySelector('.product-form__buttons .klaviyo-bis-trigger')?.classList.add('hidden');
      document.querySelector('.message__out-of-stock')?.classList.add('hidden');
    }
  }

  checkAllStock() {    
    const labels = [...this.querySelectorAll('.product__info-wrapper label.product-option__variant')];
    if(labels.length == 0) return

    if (!!labels.every(label => label.classList.contains('unavailable'))) {
      document.querySelector('.product-form__buttons .product-form__submit')?.classList.add('hidden');
      document.querySelector('.product-form__buttons .klaviyo-bis-trigger')?.classList.remove('hidden');
      document.querySelector('.message__out-of-stock')?.classList.remove('hidden');
    } else {
      document.querySelector('.product-form__buttons .product-form__submit')?.classList.remove('hidden');
      document.querySelector('.product-form__buttons .klaviyo-bis-trigger')?.classList.add('hidden');
      document.querySelector('.message__out-of-stock')?.classList.add('hidden');
    }
  }

  renderVariantStockInfo() {
    try {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`stock-alert-${this.dataset.section}`);
        const source = html.getElementById(`stock-alert-${this.dataset.section}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}

customElements.define('fostr-variant-radios', FostrVariantRadios);

class fostrClassToggleButton extends HTMLElement {
  constructor() {
    super();
    this.initializeButton();
  }

  initializeButton() {
    this.onclick = () => {
      // update all
      let targetElements = document.querySelectorAll(this.dataset.toggleElement);
      for (let i = 0; i < targetElements.length; i++) {

        // add class to target element
        if (!targetElements[i].classList.contains(this.dataset.toggleClass)) {
          targetElements[i].classList.add(this.dataset.toggleClass);
          // remove other classes ending with -col on target element
          const classes = Array.from(targetElements[i].classList);
          for (let j = 0; j < classes.length; j++) {
            if (classes[j] !== this.dataset.toggleClass && classes[j].endsWith('-col')) {
              targetElements[i].classList.remove(classes[j]);
            }
          }
        } else {
          targetElements[i].classList.remove(this.dataset.toggleClass);
          if (this.dataset.toggleClass === 'three-col') {
            targetElements[i].classList.add('two-col');
          }
        }
      }

      this.classList.toggle('toggle_on');
    };
  }
}

window.customElements.define('fostr-class-toggle-button', fostrClassToggleButton);

// PDP intersection observer
function turnHeaderOpaque() {
  const options = {
    rootMargin: '0px',
    threshold: 1,
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      // Each entry describes an intersection change for one observed
      // target element:
      const { isIntersecting } = entry;
      // turn header to opaque
      const headerWrapper = document.querySelector('.header-wrapper');

      if (isIntersecting) {
        // if intersecting then headershould be transparent
        if (headerWrapper.classList.contains('white-background')) {
          headerWrapper.classList.remove('white-background');
        }
      } else {
        headerWrapper.classList.add('white-background');
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  const upsellContainer = document.querySelector('.product .product__media-wrapper');
  if (upsellContainer !== null) {
    observer.observe(upsellContainer);
  }
}

const templateProduct = document.querySelector('#template-product');
if (templateProduct !== null) {
  turnHeaderOpaque();
}
